/**
 * components/tabs/UpstoxTab.jsx
 *
 * Desk → Positions (upstox-067: was "Upstox"; the key stays 'upstox'): the Risk Terminal (upstox-036), ported from the trader's
 * design and fed by GET /upstox/panel. Replaces the disposable Step 3
 * positions / orders / day-P&L view. Components live in
 * src/components/riskTerminal/.
 */

import React from 'react';
import RiskTerminalScreen from '../riskTerminal/RiskTerminalScreen';

export default function UpstoxTab() {
  return <RiskTerminalScreen />;
}
